/* eslint-disable no-param-reassign */
import {
  GET_PAYMENT_TRANSACTIONS_REQUEST,
  GET_PAYMENT_TRANSACTIONS_SUCCESS,
  GET_PAYMENT_TRANSACTIONS_FAILURE,
  CREATE_PAYMENT_TRANSACTION_REQUEST,
  CREATE_PAYMENT_TRANSACTION_SUCCESS,
  CREATE_PAYMENT_TRANSACTION_FAILURE
} from "src/actions/paymentTransactionActions";
import produce from "immer";

const initialState = {
  paymentTransactions: [],
  loading: false
};

const paymentTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PAYMENT_TRANSACTIONS_REQUEST: {
      return produce(state, (draft) => {
        draft.paymentTransactions = [];
        draft.loading = true;
      });
    }

    case GET_PAYMENT_TRANSACTIONS_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.paymentTransactions = response;
        draft.loading = false;
      });
    }

    case GET_PAYMENT_TRANSACTIONS_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case CREATE_PAYMENT_TRANSACTION_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case CREATE_PAYMENT_TRANSACTION_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.stations = [...draft.paymentTransactions, response];
        draft.loading = false;
      });
    }

    case CREATE_PAYMENT_TRANSACTION_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    default: {
      return state;
    }
  }
};

export default paymentTransactionReducer;
